import {HTTP} from '../../../services/api-service.js';
import commonObj from '../../../services/common.js';
var common = new commonObj();
var baseUrl = common.baseURL;

const invoiceSummaryStore = {
    namespaced: true,
    actions:{
        getSettlements({commit,state},param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/invoice/settlementEnq', param).then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                });
            });
        },  
        sendSummaryMail({commit,state}, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/invoice/sendSummaryMail', {html: param.html, EntityName: param.EntityName, Email: param.Email, DateTo: param.DateTo, printInvoiceTxNums: param.printInvoiceTxNums, rptID: param.rptID }).then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                });
            });
        }
    } 
};
export default invoiceSummaryStore;